<template>
    <div class="payroll-info-deals">
        <div class="title">
            {{ title }}
        </div>
        <div v-if="deals">
            <div class="payroll-info-deals-grid" v-loading="loading">
                <div class="row-header row-table">
                    <template v-for="(column, index) in getDealColumnsHeader">
                        <div :key="'header_' + index" class="header-cell" v-if="isVisibleColumn(column.field)">
                            {{ column.headerName }}
                        </div>
                    </template>
                </div>
                <template v-for="(deal, dealIndex) in deals">
                    <div class="row-table" :key="deal.id">
                        <template v-for="(column, columnIndex) in getDealColumnsHeader">
                            <div
                                v-if="isVisibleColumn(column.field)"
                                :key="dealIndex+ '_'+ columnIndex"
                                :class="[column.fieldClass, inEditFieldNames(column.field) ? ' text-center ' : '', 'table-cell ']"
                            >
                                <div class="cell-content">
                                    <template v-if="column.field === 'id'">
                                        <a :href="getDealLink(deal[column.field])" target="_blank" class="link">
                                            {{ deal[column.field] }}
                                        </a>
                                    </template>
                                    <template v-else-if="inEditFieldNames(column.field)">
                                        <auto-numeric
                                            v-model="deal[column.field]['accrued']"
                                            :options="getNumericOptions(column.field)"
                                            class="input-data autonumeric"
                                            @input="calculateDealAccruedAmount(deal, deal[column.field]['accrued'])"
                                        />
                                        <span class="expense-data">
                                            {{ deal[column.field]['paid'] }}
                                        </span>
                                    </template>
                                    <template v-else-if="inDetailedFieldNames(column.field)">
                                        <span>
                                            {{ formatFinance(deal[column.field]['accrued']) }}
                                        </span>
                                        <span class="expense-data">
                                            {{ formatFinance(deal[column.field]['paid']) }}
                                        </span>
                                    </template>
                                    <template v-else-if="inFinanceFieldNames(column.field)">
                                        {{ formatFinance(deal[column.field]) }}
                                    </template>
                                    <template v-else>
                                        {{ deal[column.field] }}
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
                <payroll-info-employer-deal-total
                    :deals="deals"
                    :employer-position-id="employerPositionId"
                    :has-expense-complaint-deals="hasExpenseComplaintDeals"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/payroll-info-deals.scss';
import router from '@/router/router';
import moment from 'moment';
import localReferences from '@/helpers/localReferences';
import PayrollInfoEmployerDealTotal from '@/components/salary/PayrollInfoEmployerDealTotal';

export default {
    name: 'PayrollInfoEmployerDeal',
    components: { AutoNumeric, PayrollInfoEmployerDealTotal },
    props: {
        employerId: {
            type: [Number, String],
            default: 0
        },
        reportDate: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            title: 'Начисления по сделкам',
            amount: [],
            expense: {
                details: []
            },
            deals: [{ fine_deal: { amount: '', value: 0 }, finish: { amount: '', value: 0 } }],
            employerPositionId: 0,
            totalSum: {},
            hasExpenseComplaintDeals: 0,
            dealColumnsMeasurer: [
                { headerName: 'Id сделки', field: 'id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell contract-cell-width ' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell address-cell-width ' },
                { headerName: 'м2', field: 'square_m2', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Сумма', field: 'sum', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Заключил', field: 'conclusion_id', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус %', field: 'bonus_percent', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус замерщику', field: 'bonus_by_position', fieldClass: 'grid-cell text-right pr10' }, //разные названия для замерщика и менеджера
                //{ headerName: 'Бонус менеджеру', field: 'bonus_manager', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Скидка', field: 'discount', fieldClass: 'grid-cell text-right pr10' },
                { headerName: '1% за заключение', field: 'bonus_1_percent', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус сверх 50/50', field: 'bonus_measurer', fieldClass: 'grid-cell text-right pr10' }, //только для замерщика
                { headerName: 'Бонус', field: 'bonus_deal', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Штраф', field: 'fine_deal', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Жалюзи руб', field: 'jalousie', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Отделка руб', field: 'finish', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Рекламация.материалы', field: 'complaint_materials', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Рекламация.работа', field: 'complaint_work', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Начислено', field: 'accrued', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Выдано', field: 'paid', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Остаток', field: 'residue', fieldClass: 'grid-cell cut-text text-right pr10' }
            ],
            dealColumnsManager: [
                { headerName: 'Id сделки', field: 'id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell contract-cell-width ' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell address-cell-width' },
                { headerName: 'м2', field: 'square_m2', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Сумма', field: 'sum', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Заключил', field: 'conclusion_id', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус %', field: 'bonus_percent', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус менеджеру', field: 'bonus_by_position', fieldClass: 'grid-cell text-right pr10' }, //разные названия для замерщика и менеджера
                //{ headerName: 'Бонус менеджеру', field: 'bonus_manager', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Скидка', field: 'discount', fieldClass: 'grid-cell text-right pr10' },
                { headerName: '1% за заключение', field: 'bonus_1_percent', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Бонус', field: 'bonus_deal', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Штраф', field: 'fine_deal', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Жалюзи руб', field: 'jalousie', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Отделка руб', field: 'finish', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Рекламация.материалы', field: 'complaint_materials', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Рекламация.работа', field: 'complaint_work', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Начислено', field: 'accrued', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Выдано', field: 'paid', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Остаток', field: 'residue', fieldClass: 'grid-cell cut-text text-right pr10' }
            ],
            dealColumnsDefault: [
                { headerName: 'Id сделки', field: 'id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell nowrap' },
                { headerName: 'Договор', field: 'contract', fieldClass: 'grid-cell contract-cell-width ' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell address-cell-width ' },
                { headerName: 'м2', field: 'square_m2', fieldClass: 'grid-cell cut-text ' },
                { headerName: 'Сумма', field: 'sum', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Рекламация.материалы', field: 'complaint_materials', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Рекламация.работа', field: 'complaint_work', fieldClass: 'grid-cell text-right pr10' },
                { headerName: 'Начислено', field: 'accrued', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Выдано', field: 'paid', fieldClass: 'grid-cell cut-text text-right pr10' },
                { headerName: 'Остаток', field: 'residue', fieldClass: 'grid-cell cut-text text-right pr10' }
            ],
            loading: false,
            numericOptions: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '9999999',
                isCancellable: true,
                emptyInputBehavior: 'null',
                modifyValueOnWheel: false
            },
            numericOptionsFine: {
                minimumValue: '-9999999999999',
                maximumValue: '0'
            },
            hasFineDeal: 0
        };
    },
    computed: {
        getDealColumnsHeader() {
            if (this.employerPositionId === localReferences.employerPositions.manager) {
                return this.dealColumnsManager;
            }
            if (this.employerPositionId === localReferences.employerPositions.measurer) {
                return this.dealColumnsMeasurer;
            }
            return this.dealColumnsDefault;
        },
        dealsTotalSumAccrued() {
            return this.$store.state.salary.dealsTotalSum.accrued;
        },
        dealsTotalSumPaid() {
            return this.$store.state.salary.dealsTotalSum.paid;
        },
        dealsTotalSumResidue() {
            return this.$store.state.salary.dealsTotalSum.residue;
        }
    },
    methods: {
        formatFinance,
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        async getEmployerDealPayrollInfo() {
            this.loading = true;
            await this.$store.dispatch('salary/getEmployerDealPayrollInfo', { employer_id: this.employerId, report_date: this.reportDate }).then(
                response => {
                    if (response) {
                        console.log(response.deals);
                        this.deals = response.deals;
                        this.updateDealExpenses();

                        this.hasExpenseComplaintDeals = response.hasExpenseComplaintDeals;
                        this.employerPositionId = response.employerPositionId;
                        this.totalSum = response.totalSum;

                        this.updateStoreDealTotalSum(this.totalSum);
                        console.log(response);
                    }
                },
                error => {
                    if (error.response.status === 403) {
                        console.log(error.response.data.error);
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        actionAfterSave() {
            this.$message({
                showClose: true,
                message: 'Расход сохранён',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        },
        actionAfterSaveError() {
            this.$message({
                showClose: true,
                message: 'Расход не сохранён',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        inEditFieldNames(columnName) {
            const editFields = ['bonus_deal', 'fine_deal'];
            if (editFields.indexOf(columnName) !== -1) {
                return true;
            }
            return false;
        },
        inDetailedFieldNames(columnName) {
            const detailedFields = ['bonus_1_percent', 'bonus_deal', 'jalousie', 'finish', 'complaint_materials', 'complaint_work', 'bonus_measurer'];
            if (detailedFields.indexOf(columnName) !== -1) {
                return true;
            }
            return false;
        },
        inFinanceFieldNames(columnName) {
            const financeFields = ['sum', 'accrued', 'paid'];
            if (financeFields.indexOf(columnName) !== -1) {
                return true;
            }
            return false;
        },
        getNumericOptions(columnName) {
            if (columnName === 'fine_deal') {
                return [this.numericOptions, this.numericOptionsFine];
            }
            return this.numericOptions;
        },
        isVisibleColumn(column) {
            if (column === 'complaint_materials' || column === 'complaint_work') {
                if (this.hasExpenseComplaintDeals) {
                    return true;
                }
                return false;
            }
            return true;
        },
        calculateDealAccruedAmount(deal, columnValue) {
            this.checkFineDeal();
            deal.accrued = columnValue + deal.bonus_1_percent.accrued + deal.jalousie.accrued + deal.finish.accrued + deal.complaint_work.accrued + deal.complaint_materials.accrued + parseInt(deal.fine_deal.paid) + parseInt(deal.bonus_deal.paid);
            deal.accrued = parseInt(deal.accrued);
            if (this.employerPositionId === localReferences.employerPositions.measurer) {
                deal.accrued += deal.bonus_measurer.accrued;
            }
            deal.residue = deal.accrued - deal.paid;
            const totalSum = {
                accrued: this.deals.reduce((sum, deal) => sum + +deal.accrued, 0),
                paid: this.totalSum.paid,
                residue: this.deals.reduce((sum, deal) => sum + +deal.residue, 0)
            };

            this.updateStoreDealTotalSum(totalSum);
            if (this.deals.length) {
                this.updateDealExpenses();
            }
        },
        updateStoreDealTotalSum(totalSum) {
            this.$store.dispatch('salary/setDealsTotalSum', { totalSum });
        },
        updateStoreExpensesDeals(expenses) {
            this.$store.dispatch('salary/setExpensesDeals', { expenses });
        },
        updateDealExpenses() {
            const expenses = [];
            this.deals.forEach((dealRaw, rawName) => {
                const expense = { details: { expense_type: '', amount: 0 } };
                const details = [];
                expense.created_by_id = this.$store.state.auth.employerId;
                expense.date = moment().format('YYYY-MM-DD');
                expense.report_date = this.reportDate;
                expense.recipient_type = 'employer';
                expense.recipient_id = this.employerId;
                expense.deal_id = dealRaw.id;
                expense.comment = 'Начисления. Расходы по сделке';
                const expenseTypes = ['bonus_1_percent', 'bonus_deal', 'fine_deal', 'jalousie', 'finish', 'complaint_materials', 'complaint_work', 'bonus_measurer'];
                expenseTypes.forEach((expenseName) => {
                    if ((this.employerPositionId !== localReferences.employerPositions.measurer) && expenseName === 'bonus_measurer') {
                        return;
                    }
                    if (expenseName === 'fine_deal' || expenseName === 'bonus_deal') {
                        if (parseInt(dealRaw[expenseName].accrued) !== 0) {
                            details.push({
                                expense_type: expenseName,
                                amount: dealRaw[expenseName].accrued
                            });
                        }
                        return;
                    }
                    const residue = dealRaw[expenseName].accrued - dealRaw[expenseName].paid;
                    if (residue !== 0) {
                        details.push({
                            expense_type: expenseName,
                            amount: residue
                        });
                    }
                });
                if (details.length) {
                    expense.details = details;
                    expenses.push(expense);
                }
            });
            if (expenses.length) {
                this.updateStoreExpensesDeals(expenses);
            }
        },
        checkFineDeal() {
            this.$store.dispatch('salary/seIsIssetDealFine', (this.deals.filter(item => (item.fine_deal.accrued !== 0 && item.fine_deal.accrued !== null)).length === 0) ? 0 : 1);
        }
    },
    beforeMount() {
        this.getEmployerDealPayrollInfo();
    }
};
</script>
